import { notices } from './notices'
import { signature } from '../components/signature'

const errorMessages = {
    'nl': {
        'products': 'Gelieve 1 of meerdere producten toe te voegen',
        'signature': 'Handtekening ontbreekt',
    },
    'fr': {
        'products': 'Veuillez ajouter 1 ou plusieurs produits',
        'signature': 'Signature manquante',
    }
}

class Request {
    submit(form) {
        var action = `/actions/${form.querySelector('[name=action]').value}`
        if (!action) return

        var submit = form.querySelector('[type=submit]')

        var data = new FormData(form)

        var language = document.documentElement.lang
        var errorMessages = this.getErrorMessages(language)
        notices.hideNotices()
        var notice = notices.getNotice(form)

        if (action == '/actions/_pdf/default/generate') {
            var svg = signature.getSVG()
            if (!svg) {
                notices.showErrorNotice(notice, errorMessages.signature)
                return false
            } else {
                data.append('svg', svg)
                // console.log(svg)
            }
        }
        
        return fetch('', {
            method: 'POST',
            body: data
        })
        .then(async (response) => {
            // console.log('fetch response: ', response)
            if (response.ok) {
                // console.log(await response.json())
                form.setAttribute('data-form-status', 'submitted')
                if (submit.hasAttribute('data-disable')) {
                    submit.disabled = true
                }
                
                if (action == '/actions/_pdf/default/generate') {
                    console.log('action generate')
                    // const blob = await response.blob()
                    // let tab = window.open()
                    // tab.location.href = window.URL.createObjectURL(blob)
                }
                if (action == '/actions/_pdf/default/products') {
                    const hasProducts = await response.text()
                    if (!hasProducts) {
                        notices.showErrorNotice(notice, errorMessages.products)
                        return false
                    }
                }
                // notices.showSuccessNotice(notice, 'success')
                window.location.href = response.url
            } else {
                return response.text()
            }
        })
        // .then(data => {
        //     console.log('fetch data: ', data)
        // })
        .catch(error => {
            console.log('fetch error: ', error)
            form.setAttribute('data-form-status', 'error')
            notices.showErrorNotice(notice, 'error')
        })
    }

    getErrorMessages(language) {
        switch (language) {
            case 'nl':
                var result = errorMessages['nl']
                break

            default:
                var result = errorMessages['fr']
                break
        }

        return result
    }
}

export const request = new Request()